import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"

import "./footer.vue?vue&type=style&index=0&id=1c4e7631&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4e7631"]])

export default __exports__